import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, mergeProps as _mergeProps, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b796d10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "inputs-container" }
const _hoisted_4 = { class: "inputs-items" }
const _hoisted_5 = { class: "inputs-items-row" }
const _hoisted_6 = { class: "form-element" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "form-element" }
const _hoisted_9 = { class: "form-element" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "inputs-items-row" }
const _hoisted_12 = { class: "form-element" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: 215,
  id: "TUR"
}, "TURKEY (TÜRKİYE)", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "form-element" }
const _hoisted_16 = {
  value: "",
  disabled: ""
}
const _hoisted_17 = ["value", "id"]
const _hoisted_18 = { class: "form-element" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = {
  key: 1,
  class: "contact-transfer"
}
const _hoisted_21 = { class: "check-inputgroup" }
const _hoisted_22 = ["innerHTML"]

export function render(_ctx, _cache) {
  const _component_FormTitle = _resolveComponent("FormTitle")
  const _component_VueTelInput = _resolveComponent("VueTelInput")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FormTitle, {
      count: "1",
      countTilte: _ctx.$t('countTilte2.value'),
      countMsg: _ctx.$t('countMsg2.value')
    }, null, 8, ["countTilte", "countMsg"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isError)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "contact-error",
            ref: "contactErrorBox"
          }, _toDisplayString(_ctx.$t("contactError.value")), 513))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t("fullname.value").toUpperCase()), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.cFullname) = $event)),
                placeholder: _ctx.$t('fullname.value'),
                ref: "wnameInput"
              }, null, 8, _hoisted_7), [
                [_vModelText, _ctx.cFullname]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t("wMobile.value")), 1),
              _createVNode(_component_VueTelInput, _mergeProps({
                ref: "myTelInput",
                onInput: _ctx.onInput,
                value: _ctx.cTelValue
              }, _ctx.inputOpts2, {
                modelValue: _ctx.cTelValue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.cTelValue) = $event)),
                dynamicPlaceholder: _ctx.$t('mobilephone.value')
              }), null, 16, ["onInput", "value", "modelValue", "dynamicPlaceholder"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t("wemail.value").toUpperCase()), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.cEmail) = $event)),
                placeholder: _ctx.$t('wemail.value'),
                ref: "wemailInput"
              }, null, 8, _hoisted_10), [
                [_vModelText, _ctx.cEmail]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.cCountry) = $event)),
                ref: "countryInput",
                onChange: _cache[4] || (_cache[4] = (...args) => (_ctx.countrySelect && _ctx.countrySelect(...args)))
              }, _hoisted_14, 544), [
                [_vModelSelect, _ctx.cCountry]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.cCity) = $event)),
                ref: "cityInput",
                onChange: _cache[6] || (_cache[6] = (...args) => (_ctx.citySelect && _ctx.citySelect(...args)))
              }, [
                _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.$t("city.value")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statesOpts, (state, idx) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: state.id,
                    id: state.id,
                    key: idx
                  }, _toDisplayString(state.name), 9, _hoisted_17))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.cCity]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.cTown) = $event)),
                placeholder: _ctx.$t('town.value'),
                ref: "townInput"
              }, null, 8, _hoisted_19), [
                [_vModelText, _ctx.cTown]
              ])
            ])
          ])
        ])
      ]),
      (_ctx.isContactTransferSelect)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "dataTransfer",
                value: "dataTransfer",
                onChange: _cache[8] || (_cache[8] = (...args) => (_ctx.onDataTransfer && _ctx.onDataTransfer(...args))),
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.ContactTransfer) = $event))
              }, null, 544), [
                [_vModelCheckbox, _ctx.ContactTransfer]
              ]),
              _createElementVNode("label", {
                for: "dataTransfer",
                innerHTML: _ctx.$t('contactInfoTransferMsg.value')
              }, null, 8, _hoisted_22)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}